import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Alert, Media } from '@classes/alert/alert';
import { mediaService } from '@services/media/media.service';

const reader = new FileReader();
export interface DialogData {
  alert: Alert;
  index: number;
  length: number;
  safeUrl: any;
}


@Component({
  selector: 'app-thumbnail',
  templateUrl: './thumbnail.component.html',
  styleUrls: ['./thumbnail.component.scss']
})
export class ThumbnailComponent implements OnInit {
  img: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private mediaService: mediaService,
    private sanitizer: DomSanitizer

  ) { }

  ngOnInit(): void {
    // this.initComponent();
    this.getThumbnail();
  }


  private getThumbnail() {
    const thumbnail = this.data.alert.medias.find(m => m.type === 'Thumbnail');

    let img: any;

    this.mediaService.getThumbnail(thumbnail.id).subscribe(img => {

      reader.readAsDataURL(img);
      reader.onload = (res) => {

        const urlImg = res.target.result.toString();


        this.img = this.sanitizer.bypassSecurityTrustUrl(urlImg);

      };
    });


  }



}
